import { Duration } from "luxon";

export class DurationHelper {
  public static fromJSDate(jsDate: Date): Duration {
    if (!jsDate) {
      return null;
    }
    return Duration.fromDurationLike({ hours: jsDate.getHours(), minutes: jsDate.getMinutes()});
  }
}
